import {call, put, select} from 'redux-saga/effects';
import {ISkeletonSaga, skeletonSaga} from '../../apis/skeleton/skeletonSaga';
import {GENERIC_ERROR} from '../../constants/ErrorConstants';
import {GET_EVENTS_SUCCESS} from '../../constants/MonitorConstants';
import {EventStoredObject, EventsStoredObjects, MarketCapObject, MoneyLineObject} from "../../@types/response";
import {getMarketCap} from "../../store/selectors/getMarketCap";
import {getEventsMoneyLine} from "../../store/selectors/getEventsMoneyLine";
import {getFixtures} from "../../store/selectors/getFixtures";
import {GetSnapshotMonitorCall} from "../../apis/snapshot";

function* tryFunction(filters: Record<string, any>) {
    const events: EventStoredObject[] = yield call(GetSnapshotMonitorCall, filters);
    const marketsCap: MarketCapObject = yield select(getMarketCap);
    const moneyLines: MoneyLineObject = yield select(getEventsMoneyLine);
    const fixtures: EventsStoredObjects = yield select(getFixtures);
    const merged = events.map((e: EventStoredObject) => ({...fixtures[e._id], ...e}));
    yield put({
        type: GET_EVENTS_SUCCESS,
        payload: {events: merged, marketsCap, moneyLines}
    });
}

export function* getEventsSaga({payload}: { payload: Record<string, any> }): Generator {
    const sagaPayload: ISkeletonSaga = {
        tryApiCall: {function: tryFunction, payload},
        failedType: GENERIC_ERROR
    };
    yield call(skeletonSaga, sagaPayload);
}